package ru.villawonka.app.presentation.design.components

enum class AppIconButtonType {
    DEFAULT,
    FAVORITE,
    SEMI_TRANSPARENT,
}